export default "__VITE_ASSET__BDXh7cqc__"